import TrailerEmptyIcon from '@/components/assets/icon_trailer_empty.svg'
import { useTranslations } from 'next-intl'

const TrailerCarouselEmptyState = () => {
  const t = useTranslations()
  return (
    <div className="absolute top-1/2 left-1/2 flex h-[148px] w-[261px] -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center">
      <div className="h-[72px] w-[72px]">
        <TrailerEmptyIcon className="h-full w-full object-cover" />
      </div>
      <p className="subheader2-omni-styles text-white">{t('trailer-carousel.default.title')}</p>
      <p className="body1-omni-styles text-vive-primary-30">
        {t('trailer-carousel.default.description')}
      </p>
    </div>
  )
}

export default TrailerCarouselEmptyState
